import { FC } from "react";

import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";
import cx from "apps/website/utils/misc/cx";

import Image, { IImageProps } from "../../base/Image/Image";

export interface IFrameImage {
  image: IImageProps;
  author: string;
  frameFillColour?: Theme;
}

const FrameImage: FC<IFrameImage> = ({ image, author, frameFillColour }) => {

  const computedClass = cx(
    "relative overflow-hidden",
    themeRootClassMap[frameFillColour ?? "green"],
    "h-[59px] md:h-[75px]",
    "min-w-[48px] max-w-[48px]",
    "md:min-w-[60px] md:max-w-[60px]",
  );

  return (
    <div className={computedClass}>
      <Image
        image={image}
        alt={image.alt ?? author}
        cover
      />

      <Image
        image={{
          src: "/images/features/team/48x60/frame.webp",
          width: 172,
          height: 230,
        }}
        alt=""
        className={"block w-full h-auto relative z-10 pointer-events"}
      />
    </div>
  );
};

export default FrameImage;
